// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0770f119","455":"7804627d","977":"f1e848be"}[chunkId] + ".chunk.js";
};